import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import {
    getShopifyPayoutsApi,
    getShopifyPayoutDetailsApi,
    exportShopifyPayoutDetailApi,
    getShopifyPayoutXeroInvoicesApi,
    sendToXeroApi,
} from "../../../../services/payout";


export const getShopifyPayouts = createAsyncThunk('report/getShopifyPayouts', async (data, { dispatch }) => {
    const response = await getShopifyPayoutsApi(data);
    dispatch(setShopifyPayoutsData(response.response));
    return response.response;
});

export const getShopifyPayoutDetail = createAsyncThunk('report/getShopifyPayoutDetail', async (data, { dispatch }) => {
    const response = await getShopifyPayoutDetailsApi(data);
    dispatch(setShopifyPayoutDetailsData(response.response));
    return response.response;
});

export const exportShopifyPayoutDetail = createAsyncThunk('report/exportShopifyPayoutDetail', async (data, { dispatch }) => {
    const response = await exportShopifyPayoutDetailApi(data);
    return response.response;
});

export const getShopifyPayoutXeroInvoices = createAsyncThunk('report/getShopifyPayoutXeroInvoices', async (data, { dispatch }) => {
    const response = await getShopifyPayoutXeroInvoicesApi(data);
    dispatch(setShopifyPayoutXeroInvoicesData(response.response));
    return response.response;
});

export const sendToXero = createAsyncThunk('report/sendToXero', async (data, { dispatch }) => {
    const response = await sendToXeroApi(data);
    return response.response;
});


const payoutReportAdapter = createEntityAdapter({});

export const { selectAll: selectPayoutReport, selectById: selectPayoutReportById } = payoutReportAdapter.getSelectors(
    state => state.report
);

const payoutReportSlice = createSlice({
    name: 'payoutReport',
    initialState: payoutReportAdapter.getInitialState({
        id: null,
        settings: {
            partners: [],
            deliveryPartners: [],
            shippingTypes: [],
            currencies: [],
        },
        filters: {
            startDate: null,
            endDate: null,
            partner: null
        },
        shopifyPayoutLists: [],
        shopifyPayoutTableRow: 0,
        shopifyPayoutTotalSummary: null,
        shopifyPayoutDetailLists: [],
        shopifyPayoutDetailTableRow: 0,
        shopifyPayoutDetail: null,
        shopifyPayoutDetailTotalSummary: null,
        shopifyPayoutXeroInvoiceLists: [],
        shopifyPayoutXeroInvoiceTableRow: 0,
    }),
    reducers: {
        setSettings: (state, action) => {
            state.settings.partners = action.payload.partners;
            state.settings.deliveryPartners = action.payload.delivery_partners;
            state.settings.shippingTypes = action.payload.shipping_types;
            state.settings.currencies = action.payload.currencies;
        },
        setFilter: (state, action) => {
            state.filters = action.payload;
        },
        setShopifyPayoutsData: (state, action) => {
            state.shopifyPayoutLists = action.payload.data;
            state.shopifyPayoutTableRow = action.payload.total;
            // state.shopifyPayoutTotalSummary = action.payload.total_summary;
        },
        setShopifyPayoutDetailsData: (state, action) => {
            state.shopifyPayoutDetailLists = action.payload.details.data;
            state.shopifyPayoutDetailTableRow = action.payload.details.total;
            state.shopifyPayoutDetail = action.payload.payout;
            state.shopifyPayoutDetailTotalSummary = action.payload.details.total_summary;
        },
        setShopifyPayoutXeroInvoicesData: (state, action) => {
            state.shopifyPayoutXeroInvoiceLists = action.payload.data;
            state.shopifyPayoutXeroInvoiceTableRow = action.payload.total;
        },
    },
    extraReducers: {
        // [getPayoutReport.fulfilled]: payoutReportAdapter.setAll
    }
});

export const {
    setSettings,
    setFilter,
    setShopifyPayoutsData,
    setShopifyPayoutDetailsData,
    setShopifyPayoutXeroInvoicesData,
} = payoutReportSlice.actions;

export default payoutReportSlice.reducer;